<template>
  <b-modal :title="helper.trans('labels.deal_action_confirmation', {action: helper.trans(`deals.action.confirm`)})"
           :modelValue="modal !== null"
           footer-class="d-flex justify-content-between"
           @update:modelValue="$event === false && (modal = null)">
    <template #default>
       <div class="row">
         <label for="amount" class="col-sm-4 col-form-label text-capitalize-first pe-2">{{ helper.trans("labels.sum") }}</label>
         <div class="col-sm-4">
           <input v-model="form.amount"
                  v-maska
                  data-maska="9.##"
                  data-maska-tokens="9:[0-9]:multiple"
                  type="text" class="form-control " name="amount">
         </div>
         <span class="col-sm-2 col-form-label ms-2">{{ modal?.deal.takerSum.currency }}</span>
       </div>
    </template>
    <template #footer>
      <button type="button" @click="modal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.cancel')  }}
      </button>
      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ helper.trans(`deals.action.confirm`) }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import TraderDealDTO from "@/models/TraderDealDTO";
import {numberFormatter} from "@/service/NumberFormatter";

export interface OperatorDealConfirmModalProps {
  deal: TraderDealDTO
  onOkClick(): void
}

export default defineComponent({
  components: {
    BModal,
    LoaderWrapper
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      modal: null as OperatorDealConfirmModalProps|null,
      form: {
        amount: '' as string|null
      }
    });

    const getForm = () => {
      return {
        amount: parseFloat(state.form.amount!)
      };
    }

    const show = (props: OperatorDealConfirmModalProps) => {
      state.modal = props

      if (props.deal.disputeReasonData && props.deal.disputeReasonData.amount) {
        state.form.amount = props.deal.disputeReasonData.amount.toString()
      } else {
        state.form.amount = props.deal.takerSum.amount
      }

    }

    const onOkClick = async () => {
      if (!state.modal) {
        return;
      }

      loader.value?.show()
      try {
        await state.modal.onOkClick();
      } finally {
        loader.value?.hide()
      }

      state.modal = null;
    }

    return {
      ...toRefs(state),
      onOkClick,
      show,
      loader,
      helper,
      getForm
    }
  }
})
</script>
